module.exports = __webpack_public_path__ + "img/contaminated.9ec7745e.png";